import fileSys from "../../fileoprators/fileSystem";
import { iniReader, FILES } from "../shared/index";
import CalCaseDebug from "./CalCaseDebug";
const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));
function getBorderR(iniPath) {
  let data = iniReader(iniPath);
  if (!data || !data.Surface || !data.Surface.fBorderMinR) {
    return -1;
  }
  return parseFloat(data.Surface.fBorderMinR);
}
function getDefaultParams() {
  return {
    values: {
      rs: -1,
      rf: -1,
      ecc: 0,
      dia: 8,
      shiftX: 0,
      shiftY: 0,
      rms: 0
    },
    ptrCal: 0,
    isAuto: 1,
    data: null,
    isFloat: true,
    sphereElli: 0,
    isInitial: true, // 当前rs/rf是否为初始值
    hadInitial: false
  };
}
function freeElevParams(ele) {
  if (ele && ele.ptrCal) {
    addonDT.FreeElevation(ele.ptrCal);
    ele.ptrCal = 0;
  }
}
function calElevParams(ele, casePath) {
  if (!ele || !casePath) {
    return false;
  }
  // 若qs失败,则不用计算
  if (!initElev(ele, casePath)) {
    return false;
  }
  if (ele.hadInitial === false) {
    if (!modelFit(ele) || !getParams(ele)) {
      return false;
    }
  }

  if (!modelSurface(ele) || !calcElev(ele)) {
    return false;
  }
  return true;
}
function initElev(ele, casePath) {
  let borderMinR = getBorderR(casePath + "/AC.ANA");
  if (borderMinR < 0) {
    return false;
  }
  let fileName = fileSys.combinePath(casePath, FILES.cartCrnf);
  let result;
  if (!ele.ptrCal || ele.ptrCal === 0) {
    result = addonDT.InitElevation(fileName, borderMinR);
    if (result.result !== 0) return false;
    ele.ptrCal = result.ptr;
    ele.hadInitial = false;
  }
  return true;
}
function modelFit(ele) {
  let result = addonDT.ModelFit(
    ele.ptrCal,
    ele.sphereElli,
    ele.isFloat,
    ele.isAuto === 0,
    ele.values.dia
  );

  return result.result === 0;
}
function getParams(ele) {
  let values = ele.values;
  let result = addonDT.UIGetParams(ele.ptrCal);

  values.shiftX = result.shiftX;
  values.shiftY = result.shiftY;
  values.ecc = result.ecc;
  values.rs = values.rf = result.rsrf;
  values.dia = result.diaVal;
  return true;
}
function modelSurface(ele) {
  let values = ele.values;
  let result = addonDT.ModelSurface(
    ele.ptrCal,
    values.shiftX,
    values.shiftY,
    values.rs,
    values.ecc
  );

  return result.result === 0;
}
function calcElev(ele) {
  ele.data = new Float64Array(601 * 601);
  let result = addonDT.CalcElevation(ele.ptrCal, ele.data.buffer);

  ele.values.rms = result.RMS;
  if (ele.hadInitial === false) {
    ele.hadInitial = true;
    ele.isInitial = true;
  } else {
    ele.isInitial = false;
  }

  return result.result === 0;
}
export default {
  getDefaultParams: getDefaultParams,
  cal: calElevParams,
  free: freeElevParams
};



// WEBPACK FOOTER //
// ./src/topography/js/CalElev.js